import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation  } from "react-router-dom";
import { createBooking, updateBooking } from "services/BookingService";
import { getAgents } from "services/AgentService";
import { getHotels , getHotelCategory } from "services/HotelService";
import { getCities } from "services/CityService";

const BookingForm = () => {
  const [formData, setFormData] = useState({
    customerType: "",
    companyName: "",
    state: "",
    hotelId: "",
    checkIn: "",
    checkOut: "",
    guestName: "",
    guestPhone: "",
    guestEmail: "",
    numberOfGuest: "",
    extraMattressAdult: "",
    numberOfChild: "",
    extraMattressChild: "",
    otherServices: "",
    mealPlan: "",
    totalCost: "",
    totalAdvance: "",
    rooms: [{ roomType: "", numberOfRoom: "" }],
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [agents, setAgents] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [roomTypes, setRoomTypes] = useState([]);
  const [cities, setCity] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const { isEdit, editFormData } = location.state || {
    isEdit: false,
    editFormData: {},
  };

   useEffect(() => {
      getAgentsList();
      getHotelsList();
      getCityList();
    }, []);
  
  useEffect(() => {
      if (isEdit && editFormData) {
        const {  rooms, ...rest } = editFormData;
        let parsedRooms = [];
        parsedRooms = rooms ? JSON.parse(rooms) : [];     
        setFormData({ ...rest, rooms: parsedRooms});
        getRoomTypes(editFormData.hotelId);
      }
    }, [isEdit, editFormData]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    if(name==='state')
    {
      getHotelsList(value);
    }
    if(name==='hotelId')
      {
        getRoomTypes(value);
      }
  };

    const getCityList = () => {
          getCities().then((response) => {
            if (response && response.data.success) {
              setCity(response.data.cities);
             
            }
          });
        };
  
   const getAgentsList = () => {
      getAgents().then((response) => {
        if (response && response.data.success) {
          setAgents(response.data.agents);
         
        }
      });
    };
   const getHotelsList = (state=null) => {
      getHotels(state).then((response) => {
        if (response && response.data.success) {
          setHotels(response.data.hotels);          
        }
      });
    };
  
    const getRoomTypes = (hotel_id) => {
      getHotelCategory(hotel_id).then((response) => {
        if (response && response.data.success) {
          setRoomTypes(response.data.roomcategories);          
        }
      });
    };
  

  const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
          setErrors(newErrors);
        } else {
          setErrors({});
          setLoading(true);
          const payload = {
            ...formData,
            rooms: JSON.stringify(formData.rooms),
          };
          let response;
          if (isEdit) {
            response = await updateBooking(payload);
          } else {
            response = await createBooking(payload);
          }
  
          setLoading(false);
          if (response?.data?.success) {
            navigate("/bookings");
          } else if (response?.data?.errors) {
            const serverErrors = {};
            for (const field in response.data.errors) {
              serverErrors[field] = response.data.errors[field][0];
            }
            setErrors(serverErrors);
          }
        }
      } catch (error) {
        console.error("Error adding booking:", error);
      }
    };

    const validate = () => {
      const newErrors = {};
      if (!formData.customerType) {
        newErrors.customerType = "Type is required";
      }
    
      return newErrors;
    };

  const handleRoomChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRooms = [...formData.rooms];
    updatedRooms[index][name] = value;
    setFormData({ ...formData, rooms: updatedRooms });
  };

  const addRoom = () => {
    setFormData({
      ...formData,
      rooms: [...formData.rooms, { roomType: "", numberOfRoom: "" }],
    });
  };

  const removeRoom = (index) => {
    const updatedRooms = formData.rooms.filter((_, i) => i !== index);
    setFormData({ ...formData, rooms: updatedRooms });
  };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-users"></i>
        </div>
        <div className="header-title">
          <h1>Add Booking</h1>
          <small>Add New Booking</small>
        </div>
      </section>
      <section className="content">
        <div className="row">
          <div className="col-sm-12">
            <div
              className="card lobicard all_btn_card"
              id="lobicard-custom-control1"
              data-sortable="true"
            >
              <div className="card-header all_card_btn">
                <div className="card-title custom_title">
                  <Link className="btn btn-add" to="/bookings">
                    <i className="fa fa-list"></i> Bookings List{" "}
                  </Link>
                </div>
              </div>
              <div className="card-body">
                <form className="col-sm-12" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Customer Type */}
                    <div className="col-md-6 mb-3">
                      <label>Customer Type</label>
                      <select
                        name="customerType"
                        value={formData.customerType}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Customer Type</option>
                        <option value="B2B">B2B</option>
                        <option value="B2C">B2C</option>
                      </select>
                    </div>
                    {/* Company Name */}
                    {formData.customerType === "B2B" ? (
                      <div className="col-md-6 mb-3">
                        <label>Company Name</label>
                        <select
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          className="form-control"
                        >
                          <option value="">Company Name</option>
                          
                        { agents.map((agent) => (
                          <option value={agent.id}>{agent.company_name}</option>
                        ))}
                         
                        </select>
                      </div>
                    ) : (
                      <div className="col-md-6 mb-3">
                        <label>Person Name</label>
                        <input
                          type="text"
                          name="companyName"
                          value={formData.companyName}
                          onChange={handleChange}
                          className="form-control"
                          required
                        />
                      </div>
                    )}
                    {/* State */}
                    <div className="col-md-6 mb-3">
                      <label>City</label>
                      <select
                        name="state"
                        value={formData.state}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Select City</option>
                        {cities.map((city) => (
                          <option value={city.city_name}>
                            {city.city_name}
                          </option>
                        ))}
                      </select>
                    </div>
                    {/* Booking Name */}
                    <div className="col-md-6 mb-3">
                      <label>Hotel Name</label>
                      <select
                        name="hotelId"
                        value={formData.hotelId}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Select Booking</option>
                       { hotels.map((hotel) => (
                          <option value={hotel.id}>{hotel.name}</option>
                        )) }
                        
                      
                      </select>
                    </div>
                    {/* Check-in and Check-out Dates */}
                    <div className="col-md-6 mb-3">
                      <label>Check-in Date</label>
                      <input
                        type="date"
                        name="checkIn"
                        value={formData.checkIn}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Check-out Date</label>
                      <input
                        type="date"
                        name="checkOut"
                        value={formData.checkOut}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Room Type */}
                    {/* Room Type - Dynamic Fields */}
                    <div className="col-md-12 mb-3 ml-3">
                      <div className="row room-types">
                        {formData.rooms.map((room, index) => (
                          <div
                            className="row mb-3"
                            key={index}
                            style={{ width: "100%" }}
                          >
                            <div className="col-md-6">
                              <label>Room Type</label>
                              <select
                                name="roomType"
                                value={room.roomType}
                                onChange={(e) => handleRoomChange(index, e)}
                                className="form-control"
                                required
                              >
                                <option value="">Select Room Type</option>
                                { roomTypes.map((type) => (
                                  <option value={type.room_type}>{type.room_type}</option>
                                )) }
                              </select>
                            </div>

                            <div className="col-md-5">
                              <label>Number Of Room</label>
                              <input
                                type="number"
                                name="numberOfRoom"
                                value={room.numberOfRoom}
                                onChange={(e) => handleRoomChange(index, e)}
                                className="form-control"
                              />
                            </div>

                            <div className="col-md-1 d-flex align-items-end">
                              {index === 0 ? (
                                <button
                                  title="add"
                                  type="button"
                                  className="btn btn-add btn-sm"
                                  onClick={addRoom}
                                >
                                  <i className="fa fa-plus"></i>
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={() => removeRoom(index)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Guest Details */}
                    <div className="col-12 mb-3">
                      <h5>
                        <b>Guest Details</b>
                      </h5>
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Guest Name</label>
                      <input
                        type="text"
                        name="guestName"
                        value={formData.guestName}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Guest Phone No.</label>
                      <input
                        type="tel"
                        name="guestPhone"
                        value={formData.guestPhone}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    <div className="col-md-4 mb-3">
                      <label>Guest Email ID</label>
                      <input
                        type="email"
                        name="guestEmail"
                        value={formData.guestEmail}
                        onChange={handleChange}
                        className="form-control"
                      />
                    </div>
                    {/* Guest Numbers */}
                    <div className="col-md-6 mb-3">
                      <label>Number of Guest</label>
                      <input
                        type="number"
                        name="numberOfGuest"
                        value={formData.numberOfGuest}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Extra Mattress For Adult</label>
                      <input
                        type="number"
                        name="extraMattressAdult"
                        value={formData.extraMattressAdult}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Number of Child (Less Than 6 Years)</label>
                      <input
                        type="number"
                        name="numberOfChild"
                        value={formData.numberOfChild}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Extra Mattress For Child</label>
                      <input
                        type="number"
                        name="extraMattressChild"
                        value={formData.extraMattressChild}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Other Services */}
                    <div className="col-md-6 mb-3">
                      <label>Other Services</label>
                      <input
                        type="text"
                        name="otherServices"
                        value={formData.otherServices}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    {/* Meal Plan */}
                    <div className="col-md-6 mb-3">
                      <label>Meal Plan</label>
                      <select
                        name="mealPlan"
                        value={formData.mealPlan}
                        onChange={handleChange}
                        className="form-control"
                      >
                        <option value="">Select Meal Plan</option>
                        <option value="MAP">MAP</option>
                        <option value="AP">AP</option>
                        <option value="CP">CP</option>
                        <option value="EP">EP</option>
                      </select>
                    </div>
                    {/* Total Cost and Advance */}
                    <div className="col-md-6 mb-3">
                      <label>Total Cost</label>
                      <input
                        type="number"
                        name="totalCost"
                        value={formData.totalCost}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label>Total Advance</label>
                      <input
                        type="number"
                        name="totalAdvance"
                        value={formData.totalAdvance}
                        onChange={handleChange}
                        className="form-control"
                        required
                      />
                    </div>
                    <div className="col-12 mb-3">
                    
                      <button type="submit" className="btn btn-success" disabled={loading}>
                      {loading ? "Saving..." : "Save"}
                    </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BookingForm;
